import { Link } from 'gatsby'
import React from 'react'

import { CustomSliderContainer, Image } from 'src/ui/atoms'
import { breakpoints, useDimensions } from 'src/ui/dimensions'
import { HBox, Row, Wrapper } from 'src/ui/layout'
import { styled, useTheme } from 'src/ui/theme'
import { Body, Header, Label } from 'src/ui/typography'
import { SwiperSlider } from 'src/ui/organisms'
import { TSliderItem } from '../hero-block/types'
import { useSliderSwipe } from 'src/shared/hooks'
import { SwiperSlide } from 'swiper/react/swiper-react.js'
import { sliderRestSettings } from 'src/shared/constants'

const StyledRow = styled(Row)`
  display: grid;

  grid-template-columns: auto auto auto;
  gap: 48px;

  @media (max-width: ${breakpoints.tablet}px) {
    grid-template-columns: auto;
  }
`

const Container = styled(CustomSliderContainer)`
  position: relative;
  .swiper-pagination-rest {
    position: absolute;
    left: 0;
    right: 0;
    margin-inline: auto;
    width: fit-content;
    bottom: 26px;
    align-items: start;
  }

  button.swiper-pagination-bullet svg circle#spinner {
    animation-duration: 2s;
  }
`

const SliderItem = styled.div`
  /* height: 566px; */
`

const Video = styled.video`
  display: block;
  position: absolute !important;
  object-fit: cover;
  right: 0;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  margin: 0 auto;
`

const StyledCol = styled.div`
  display: flex;
  flex-flow: column;
`

const StylesImage = styled(Image)`
  z-index: 0;
  mix-blend-mode: multiply;
`

const HoverTitle = styled.div`
  opacity: 0;
  position: absolute;

  left: 64px;
  bottom: 64px;
  max-width: 320px;
  padding: 0 16px;
  z-index: 2;

  transition: opacity 0.3s;
`

const HoverWrapper = styled.div`
  position: relative;
  height: 528px;
  background: ${({ theme }) => theme.colors.white.primary};
`

type Props = {
  images: TImages
  sliderItems: TSliderItem[]
}

const data = [
  {
    title: `Развлекаемся`,
    description: `Сотрудники KODE любят проводить время друг с\u00A0другом, поэтому регулярно встречаются за пределами офиса: ходят в\u00A0кино, на\u00A0концерты и лекции, посещают мастер-классы.`,
    link: `/fun`,
  },
  {
    title: `Занимаемся творчеством`,
    description: `Наша музыкальная кавер-группа «Ласковый\u00A0дедлайн» выступает на\u00A0корпоративах и\u00A0не\u00A0только.`,
    link: `/fun/#band`,
  },
  {
    title: `Путешествуем`,
    description: `Исследуем туристические маршруты вокруг Калининграда. А дважды в год отправляемся заграницу вместе с коллегами. Например, мы видели китов в Баренцевом море, угощались восточными сладостями в Марокко и гуляли по старым улицам Дербента.`,
    link: `/fun/#travel`,
  },
]

export const Rest: React.FC<Props> = ({ images, sliderItems }) => {
  const theme = useTheme()
  const { innerWidth } = useDimensions()
  const { sliderRef, handleMouseDown, handleMouseUp } = useSliderSwipe()

  return (
    <Wrapper>
      <Label weight="bold">ОТДЫХ</Label>
      <HBox height={24} />
      <Header size="h2" as="h2">
        Жизнь вне офиса
      </Header>
      <HBox height={72} />

      <StyledRow>
        {data.map((item, i) => (
          <StyledCol key={i}>
            <Header size="h4" as="h3">
              {item.title}
            </Header>
            <HBox />
            <Body>{item.description}</Body>
            <HBox height={8} />
            <Body>
              <Link to={item.link}>Подробнее →</Link>
            </Body>
          </StyledCol>
        ))}
      </StyledRow>

      <HBox height={64} />
      <HoverWrapper>
        <Container>
          <SwiperSlider
            key="rest"
            paginationEl=".swiper-pagination-rest"
            ref={sliderRef}
            settings={sliderRestSettings}
            customPagination
          >
            {sliderItems.map((item, index) => {
              if (item) {
                return (
                  <SwiperSlide key={index}>
                    <SliderItem>
                      <StylesImage
                        objectFit="cover"
                        objectPosition={'center center'}
                        fluid={item.image}
                        height={600}
                      />
                    </SliderItem>
                  </SwiperSlide>
                )
              }
            })}
          </SwiperSlider>
          <div className="swiper-pagination-rest"></div>
        </Container>
      </HoverWrapper>
    </Wrapper>
  )
}
